module.exports = __webpack_public_path__ + "img/PVillager64_ua.f5c649fa.webp";